import React from "react";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import "../../Styles/index.sass";
import MapPage from "../MapPage";

const App = () => {
  return (
    <BrowserRouter>
      <div className="App">
        <Switch>
          <Route path="/" render={() => <MapPage />} />
          <Route render={() => <Redirect to="/" />} />
        </Switch>
      </div>
    </BrowserRouter>
  );
};

export default App;
